export const EMPTY_TOP_SEARCHES = {
    list: [],
    categories: [],
    regions: [],
    popularCities: []
};

export const SITEMAP_TABS_CLASSIFIED = [
    {
        key: 'most-popular',
        to: '/sitemap/most-popular',
        text: 'mostPopular'
    },
    {
        key: 'categories',
        to: '/sitemap/categories',
        text: 'categories'
    },
    {
        key: 'states',
        to: '/sitemap/states',
        text: 'states'
    },
    {
        key: 'cities',
        to: '/sitemap/cities',
        text: 'cities'
    },
    {
        key: 'popular-searches',
        to: '/sitemap/popular-searches',
        text: 'popularSearches'
    }
];

